import { getAuthAxiosBackend } from "@/helpers/axios"

class GovernoratesServices {
    get(id) {
        return getAuthAxiosBackend().get('Governorates/getGovernorate/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Governorates/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Governorates/addGovernorate', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Governorates/updateGovernorate/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Governorates/restoreGovernorate/' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Governorates/softDeleteGovernorate/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Governorates/deleteGovernorate/' + id.toString())
    }
}

export default new GovernoratesServices()
